import { render } from "./five_key.vue?vue&type=template&id=23ff74bd&scoped=true"
import script from "./five_key.vue?vue&type=script&lang=js"
export * from "./five_key.vue?vue&type=script&lang=js"

import "./five_key.vue?vue&type=style&index=0&id=23ff74bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ff74bd"]])

export default __exports__